import { create } from 'zustand';

interface CartSurplusItensErrorAlertModalStore {
  isOpen: boolean;
  onOpen: () => void;
  onClose: () => void;
}

export const useCartSurplusItensErrorAlertModal = create<CartSurplusItensErrorAlertModalStore>((set) => ({
  isOpen: false,
  onOpen: () => set({ isOpen: true }),
  onClose: () => set({ isOpen: false })
}));
